import { ItemCollection } from "../dto/item/ItemCollection";
export default class CheckoutProgressEvent {
    constructor() {
        this.currency = 'EUR';
        this.checkoutType = '';
        this.itemCollection = new ItemCollection();
    }
    export() {
        return {
            currency: this.currency,
            items: this.itemCollection.export(),
            checkout_type: this.checkoutType
        };
    }
}
